import { expVal } from '@confluence/feature-experiments';

/**
 * Re-evaluates experiments in the browser when their initial evaluation cannot emit an exposure.
 */
export const fireSSRExperimentExposures = () => {
	expVal('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
	expVal('confluence_ssr_use_statsig_native_bootstrap', 'isEnabled', false);
	expVal('confluence_skip_ors_shortcut_smartlinks', 'isEnabled', false);
	expVal('confluence_skip_ors_for_smartlinks', 'isEnabled', false);
	expVal('confluence_media_token_preload_agg_query', 'isEnabled', false);
	expVal('confluence_ssr_global_obj_length', 'isEnabled', false);
};
